module.exports = __webpack_public_path__ + "static/media/CUDDLER.70d5baaf.svg";